import { render, staticRenderFns } from "./income_inlinedetail.vue?vue&type=template&id=f752088c&scoped=true&"
import script from "./income_inlinedetail.vue?vue&type=script&lang=js&"
export * from "./income_inlinedetail.vue?vue&type=script&lang=js&"
import style0 from "./income_inlinedetail.vue?vue&type=style&index=0&id=f752088c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f752088c",
  null
  
)

export default component.exports